import { render, staticRenderFns } from "./NewsDetailsTwo.vue?vue&type=template&id=6ae94c9e"
import script from "./NewsDetailsTwo.vue?vue&type=script&lang=js"
export * from "./NewsDetailsTwo.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailsTwo.vue?vue&type=style&index=0&id=6ae94c9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports